import {
  GetSystemMaintenanceAction,
  NotificationsFromStore,
  RBACAction,
  SignalRConnectionAction,
} from './actions';
import {
  GET_SYSTEM_MAINTENANCE_INITIAL_STATE,
  IGetSystemMaintenanceState,
  INotificationsFromStoreState,
  ISignalRConnectionState,
  IRBACState,
  NOTIFICATIONS_FROM_STORE_INITIAL_STATE,
  SIGNALR_CONNECTION_INITIAL_STATE,
  RBAC_CONFIG_INITIAL_STATE,
} from './state';
import * as constants from 'shared/stateManagement/constants';
import i18n from 'i18next';

export function signalRConnection(
  state: ISignalRConnectionState = SIGNALR_CONNECTION_INITIAL_STATE,
  action: SignalRConnectionAction
): ISignalRConnectionState {
  switch (action.type) {
    case constants.SIGNALR_CONNECTION_STARTED:
      return {
        isConnected: false,
        connecting: true,
        signalRConnection: state.signalRConnection
          ? state.signalRConnection
          : null,
      };
    case constants.SIGNALR_CONNECTION_SUCCESS:
      return {
        isConnected: true,
        connecting: false,
        signalRConnection: action.payload.signalRConnection,
      };
    case constants.SIGNALR_CONNECTION_FAILED:
      return {
        isConnected: false,
        connecting: false,
        signalRConnection: state.signalRConnection
          ? state.signalRConnection
          : null,
      };
    default:
      return state;
  }
}

export function notificationsFromStore(
  state: INotificationsFromStoreState = NOTIFICATIONS_FROM_STORE_INITIAL_STATE,
  action: NotificationsFromStore
): INotificationsFromStoreState {
  switch (action.type) {
    case constants.GET_NOTIFICATIONS_FROM_STORE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_NOTIFICATIONS_FROM_STORE_SUCCESS: {
      return {
        ...state,
        notifications: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_NOTIFICATIONS_FROM_STORE_FAILED: {
      return {
        ...state,
        error: i18n.t('failToLoadNotificationsFromStore'),
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function systemMaintenance(
  state: IGetSystemMaintenanceState = GET_SYSTEM_MAINTENANCE_INITIAL_STATE,
  action: GetSystemMaintenanceAction
): IGetSystemMaintenanceState {
  switch (action.type) {
    case constants.GET_SYSTEM_MAINTENANCE_STARTED: {
      return {
        ...state,
        isFetchingData: true,
      };
    }
    case constants.GET_SYSTEM_MAINTENANCE_SUCCESS:
    case constants.GET_SYSTEM_MAINTENANCE_SIGNALR_SUCCESS: {
      return {
        ...state,
        maintenance: action.payload,
        isFetchingData: false,
      };
    }
    case constants.GET_SYSTEM_MAINTENANCE_FAILED: {
      return {
        ...state,
        error: action.payload?.errorMessage,
        isFetchingData: false,
      };
    }
    default:
      return state;
  }
}

export function rbac(
  state: IRBACState = RBAC_CONFIG_INITIAL_STATE,
  action: RBACAction
) {
  switch (action.type) {
    case constants.SET_RBAC_CONFIGURATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
